import OrderInterval from '../symbols/orderInterval';

const orderIntervalSetIntervalAction = (interval: number) => ({
  type: OrderInterval.SET_ORDER_INTERVAL,
  payload: interval
});

export function setOrderInterval(interval: number) {
  return (dispatch: any) => {
    dispatch(orderIntervalSetIntervalAction(interval));
  };
}